
/*
* Copyright (c) 2021.  Blacksheepz media B.V.
* https://www.blacksheepz-media.com
* Ramon van Ophuizen
*/

import React, { createContext, useEffect, useState, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_ALL_PRODUCTS } from '../queries'
import { useThemeData } from '../context/ThemeDataContext'
import { useAuthData } from './AuthProvider'
import Loading from "../screens/loading";
import { useCallback } from 'react'
import {getRoles} from "../services/auth.service";

export const PhotoBasicDataContext = createContext(null)

export function usePhotoBaseData() {
  return useContext(PhotoBasicDataContext)
}

export function PhotoBasicDataProvider ({ children }) {
  const site_id = useThemeData().themeData.site.site_id;
  const photographerType = useThemeData().photographerType;
  const {auth, login_name, loadingLogin, setLoadingLogin} = useAuthData();

  const initialData = {
    photoDefaultSettings: {
      user_id: undefined,
      default_photo_id: undefined,
      default_keuzeset_id: undefined,
      default_categorie_id: undefined,
      default_photographer_id: undefined,
    },
    photoData: [],
    schoolInfo: {
      default_school_id: undefined,
      default_school_logo: undefined,
      folder_name: undefined,
      administratiekosten: undefined,
      foreign: undefined
    }
  }

  const [photoBasicData, setPhotoBasicData] = useState(initialData)

  const { refetch: refetchPhotos, error: errorPhotos, loading: loadingPhotos, data: dataPhotos } =
    useQuery(GET_ALL_PRODUCTS, {
      fetchPolicy: 'cache-first',
      variables: {
        site_id: site_id,
        login_name: login_name,
        folder_id: null
      },
      skip: !auth || site_id === '' || photographerType === 'printservice'  || getRoles() === 'school' || !login_name || photoBasicData.photoDefaultSettings.user_id !== undefined,
      onError (...error) {
        let session_id = localStorage.getItem('session_id')
        localStorage.clear()
        localStorage.setItem('session_id', session_id)
        //hier moeten meldingen komen en er moet een mooi loguit functie komen
      }
    })

  const setPhotoData = useCallback((data) => {
    return new Promise((resolve, reject) => { 
      resolve(setPhotoBasicData({
        refetchPhotos: refetchPhotos,
        photoDefaultSettings: {
          user_id: data[0].user_id,
          default_photo_id: data[0].id,
          default_keuzeset_id: data[0].folder.productlist.keuzeset_id,
          default_categorie_id: data[0].productcategory[0].categorie_id,
          default_photographer_id: data[0].folder.photographer_id,
        },
        photoData: data,
        schoolInfo: {
          default_school_id: data[0].folder.school_id,
          default_school_logo: data[0].folder.school_logo,
          folder_name: data[0].folder.school_folder_naam,
          verzendkostenvrij_korting_datum: data[0].folder.verzendkosten_korting,
          verzendkostenvrij_per_post: data[0].folder.verzendkostenvrij_per_post,
          administratiekosten: data[0].folder.administratiekosten,
          foreign: data[0].folder.foreign
        }
      })
    )}).then(() => {
      setLoadingLogin(false);
    })
  }, [refetchPhotos, setLoadingLogin])

  useEffect(() => {
    if (!loadingPhotos && !errorPhotos) {
      if (dataPhotos) {
        async function fetchData() {
          return new Promise((resolve, reject) => {
            if (dataPhotos.photos.data.length === 0) {
              reject('no photos were found or no product list')
              alert('no photos were found or no product list');
            } else {
              resolve(dataPhotos.photos.data);
            }
          }).then((data) =>{
            localStorage.setItem('photographer_id', data[0].folder.photographer_id) // theme context needs this
            localStorage.setItem('school_logo', data[0].folder.school_logo) //navbar
            return setPhotoData(data);
          }, (error) => {
            return console.error(error)
          })
        }
        fetchData();
      }
    }
  }, [dataPhotos, loadingPhotos, errorPhotos, setPhotoData]);

  if (loadingPhotos || loadingLogin) return <Loading />
  if (auth && (!photoBasicData || !photographerType)) return null

  return (
    <PhotoBasicDataContext.Provider value={photoBasicData}>
      {children}
    </PhotoBasicDataContext.Provider>
  )
}
